import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const TransactionFormMain = lazy(
  () => import('../transactions/TransactionFormMain')
);

export default [
  {
    id: NavConfig.linkConfigs.TRANSACTION.id,
    path: NavConfig.linkConfigs.TRANSACTION.to,
    element: <TransactionFormMain />,
  },
] as RouteObject[];
